import { LandingState } from '../landing.state';
import { GridOptions } from '../model/grid-options.model';
import { GridType } from '../model/grid-type.model';

export function createNextGridState(
    type: GridType,
    state: LandingState,
    nextState: LandingState,
): GridOptions {
    switch (type) {
        case GridType.FOR_ME:
            nextState.forMe =
                nextState.forMe === state.forMe
                    ? { ...state.forMe }
                    : nextState.forMe;
            return nextState.forMe;
        case GridType.BY_ME:
            nextState.byMe =
                nextState.byMe === state.byMe
                    ? { ...state.byMe }
                    : nextState.byMe;
            return nextState.byMe;
        case GridType.FOR_MY_TEAM:
            nextState.forMyTeam =
                nextState.forMyTeam === state.forMyTeam
                    ? { ...state.forMyTeam }
                    : nextState.forMyTeam;
            return nextState.forMyTeam;
    }
}
